import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ProductCollectionUnitsGuard {
  constructor(private readonly router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): UrlTree | boolean {
    if (route.queryParams['id']) {
      return true;
    }

    return this.router.createUrlTree(['/products']);
  }
}
